import { render, staticRenderFns } from "./updatepass.vue?vue&type=template&id=3e6c8d9e&scoped=true"
import script from "./updatepass.vue?vue&type=script&lang=js"
export * from "./updatepass.vue?vue&type=script&lang=js"
import style0 from "./updatepass.vue?vue&type=style&index=0&id=3e6c8d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6c8d9e",
  null
  
)

export default component.exports